import { NgForm, FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Company } from 'src/app/shared/models/companies';
import { Program } from 'src/app/shared/models/programs';
import { CompaniesService } from 'src/app/shared/services/companies.service';
import { ProgramsService } from 'src/app/shared/services/programs.service';
import { UtilitiesService } from 'src/app/shared/services/utilities.service';
import * as _ from 'lodash';
import { AnonymousSubject } from 'rxjs/internal/Subject';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-detail',
  templateUrl: './detail.component.html',
  styleUrls: ['./detail.component.scss']
})
export class DetailComponent implements OnInit {
  pdfSrc: any;
  statusContrato: number = 0;
  idContrato: string;
  widgetId: string;
  _subscriptions: Subscription[] = [];
  company: Company;
  companyId: string;
  selectedProgram: any;
  programsObj: Program[] = [];
  response_upload: Number;
  popupVisible = false;
  firmaPopupVisible = false;
  documentoPopupVisible = false;  
  disabledButton = false;
  hasNewProgram: boolean = false;
  loadIndicatorVisible = false;
  buttonText = 'Subir';
  programsArray = [];
  udta: any;
  docs = {
    logo: '',
    rfc: '',
    actaConstitutiva: '',
    comprobanteDomicilio: '',
    identificacion: '',
    id: '',
    efos: '',
    rpc: ''
  };
  URL_BUCKET_CHECKLIST = 'https://s3.us-east-2.amazonaws.com/backend.ihunter.io/';

  // Files
  uploadLogoForm: FormGroup;
  uploadRFCForm: FormGroup;
  uploadActaForm: FormGroup;
  uploadCompDomForm: FormGroup;
  uploadIDForm: FormGroup;
  uploadEFOSForm: FormGroup;
  uploadRPCForm: FormGroup;
  UploadFile: File;
  UploadType: number;
  fileName: string;

  constructor(
    private companiesService: CompaniesService,
    private utilitiesService: UtilitiesService,
    private route: ActivatedRoute,
    private router: Router,
    private programsService: ProgramsService,
  ) {
    if (this.route.snapshot.params['id']) {
      this.companyId = this.route.snapshot.params['id'];
    } else {
      const cdta = this.utilitiesService.getCompanyData();
      this.companyId = cdta.id;
    }
    this._subscriptions.push(
      this.companiesService.getCompany(this.companyId).subscribe(company => {
        console.log(company);
        this.company = new Company(company);
        console.log(this.company);
        this.docs = this.getCompanyDocs(this.company);
        console.log(this.docs);

      }),
      this.programsService.getPrograms().subscribe(programs => {
        programs.forEach(prog => {
          const tempProg: any = {};
          tempProg.programId = prog.id;
          tempProg.programName = prog.name;
          this.programsObj.push(tempProg);
        });
        this.cleanProgramsList()
      })
    );
    this.udta = this.utilitiesService.getUserData();
  }

  cleanProgramsList() {
    this.company.programs.forEach(element => {
      this.programsObj = _.reject(this.programsObj, ['programId', element.programId]);
    });
  }

  ngOnInit(): void {
    this.getStatus();
    this.uploadLogoForm = new FormGroup({
      logo: new FormControl()
    });
    this.uploadRFCForm = new FormGroup({
      rfc: new FormControl()
    });
    this.uploadActaForm = new FormGroup({
      acta: new FormControl()
    });
    this.uploadCompDomForm = new FormGroup({
      compdom: new FormControl()
    });
    this.uploadIDForm = new FormGroup({
      id: new FormControl()
    });
    this.uploadEFOSForm = new FormGroup({
      efos: new FormControl()
    });
    this.uploadRPCForm = new FormGroup({
      rpc: new FormControl()
    });
  }

  ngOnDestroy() {
    this._subscriptions.forEach((sub) => sub.unsubscribe);
  }

  addProgram() {
    this.popupVisible = true;
  }

  checkPrograms(data) {
    this.selectedProgram = data;
  }

  addNewProgram(params) {
    if (params.validationGroup.validate().isValid) {
      const tempObj: any = {};
      tempObj.programId = this.selectedProgram.programId;
      tempObj.programName = this.selectedProgram.programName;
      const d = new Date();
      const n = d.valueOf(); // Aqui es donde se tiene que generar el Numero UNICO  de convenio del cliente con el programa
      tempObj.agreementNNumber = n;
      this.company.programs.push(tempObj);
      // Actualizar Company en Firebase
      this.popupVisible = false;
      this.companiesService.updateCompany(this.company.id, this.company).then(data => {
        this.cleanProgramsList();
        this.utilitiesService.notifyMe('Programa agregado', 'success');
      });
    }
  }

  viewCompanyProgram(e) {
    let programId = e;
    this.router.navigate([`/dash/user-detail/${programId}/${this.companyId}`]);
  }
  getStatus(){
    this.companiesService.getStatusContrato(this.companyId).subscribe(res => {
      if (res.data.length > 0) {
        this.statusContrato = res.data[0].status;
        this.idContrato = res.data[0].idContrato;
        this.widgetId = res.data[0].widgetId;
      }
    })
  }
  firmarContrato() {
    console.log('this.widgetId',this.widgetId);
    
    console.log('FirmarContrato');
    window['mifiel']=window['mifiel']||[],function(){"use strict";for(var e=["widget"],i=function(e){return function(){window['mifiel'].push([e].concat(Array.prototype.slice.call(arguments,0)))}},t=0;t<e.length;t++){var n=e[t];window['mifiel'][n]||(window['mifiel'][n]=i(n))}if(!document.getElementById("mifiel-js")){var r=document.createElement("script"),o=document.getElementsByTagName("script")[0];r.type="text/javascript",r.id="mifiel-js",r.async=!0,r.src=`https://${environment.mifielENV}.mifiel.com/sign-widget-v1.0.0.js`,o.parentNode.insertBefore(r,o)}}();
    window['mifiel'].widget({
      widgetId: this.widgetId,
      appendTo: 'mifiel-widget',
      successBtnText: 'Proceed to next step'
    });

    this.firmaPopupVisible = true;
  }
  enviarAFirma(){
    this.companiesService.enviarContratoAFirma(this.company).subscribe(res => {
      this.utilitiesService.notifyMe(`Contrato enviado a Firma`, 'succes');
      this.idContrato = res.id;
      this.widgetId = res.signers[0].widget_id;
      // Comentario Regresar idContrato de Mi Fiel
      this.companiesService.changeStatusContrato(res.id,this.companyId,1, res.signers[0].widget_id).subscribe(res => {
        this.documentoPopupVisible = false;
        this.getStatus();
      });
    });
  }
  verContrato() {
    console.log('VerContrato');
    this.companiesService.crearContrato(this.company).subscribe(res => {
      var pdf = res as ArrayBuffer;
      let file = new Blob([pdf], { type: 'application/pdf' });
      var fileURL = URL.createObjectURL(file);
      this.pdfSrc = fileURL;
      this.documentoPopupVisible = true;
    }, error => {
      if (error) {
        this.utilitiesService.notifyMe('Faltan campos en el contrato!', 'error');
        // this.utilitiesService.notifyMe(`Campos faltantes ${error.error.message}`, 'error');
      }
    })
    
  }
  editarEmpresa(e) {
    this.router.navigate(['/dash/companies/update//', {idCompany : this.company.id}]);
  }

  /**
   * Files upload checklist
   * @param event (change file listener event)
   * @param type (1-LOGO, 2-RFC, 3-ActaConstitutuva, 4-ComprobanteDomicilio, 5-ID, 6-EFOS, 7-RPC)
   */
  onChangeFile(event, type,docType?) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.UploadType = type;
      this.UploadFile = file;
      this.fileName = file.name;
      var extension = this.fileName.split('.')[1];
      console.log('extension',extension);
    }
  }
  onSubmitFile(e, type) {
    
    const formData = new FormData();
    formData.append('file', this.UploadFile);
    formData.append('docs', JSON.stringify(this.docs));
    formData.append('companyName', this.company.companyLegalName);
    formData.append('companyId', this.companyId);
    formData.append('type', type);

    this.loadIndicatorVisible = true;
    this.buttonText = 'Cargando...';
    this.disabledButton = true;

    this.utilitiesService.uploadFilesDetail(formData).subscribe(res => {
      setTimeout(() => {
        this.buttonText = 'Subir';
        this.loadIndicatorVisible = false;
        this.disabledButton = false;
      }, 2500);
      this.utilitiesService.notifyMe('Carga del documento exitosamente!', 'success');
    });
  }

  getCompanyDocs(_Company: Company): any {
    let _docs: any = {};
    Object.keys(this.docs).forEach((key,index) => _docs[key] = _Company.docs[key] ? _Company.docs[key] : null);
    return _docs;
  }
}